import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { getBusinessCategories, getOccupationOptions } from '@/api/employment';
import { getFeatures } from '@/api/features';

import { Tenant } from '@/types/common';
import { DictionaryType } from '@/types/dictionary';
import { Language } from '@/types/i18n';

export const setTenant = createAction<{ tenant: Tenant; language?: Language }>(
  'configs/set-tenant',
);

export const fetchFeatures = createAsyncThunk(
  'configs/fetch-features',
  getFeatures,
);

export const fetchOccupations = createAsyncThunk(
  'configs/fetch-occupations',
  getOccupationOptions,
);

export const fetchDirectorOccupations = createAsyncThunk(
  'configs/fetch-director-occupations',
  () => getOccupationOptions(DictionaryType.OCCUPATION_DIRECTOR),
);

export const fetchBusinessCategories = createAsyncThunk(
  'configs/fetch-business-categories',
  () => getBusinessCategories(),
);
